import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {

  constructor(private http: HttpClient) { }

  getResources() {

    return this.http.get(
      environment.baseURL + 'api/f/digital-download/list'
    );

  }

  getResource(slug: string) {

    return this.http.get(
      environment.baseURL + 'api/f/digital-download/' + slug
    );

  }

}